export default __webpack_public_path__ + "media/66b18f1baa9ca670d5bbf8e9c041303fd8d54522f130e43262c04df8b03e11a0.svg";